import { render, staticRenderFns } from "./CustomerSyncCard.vue?vue&type=template&id=c6ad06dc&scoped=true"
import script from "./CustomerSyncCard.vue?vue&type=script&lang=js"
export * from "./CustomerSyncCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerSyncCard.vue?vue&type=style&index=0&id=c6ad06dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ad06dc",
  null
  
)

export default component.exports